import script from "./PrintSettings.vue?vue&type=script&setup=true&lang=js"
export * from "./PrintSettings.vue?vue&type=script&setup=true&lang=js"

import "./PrintSettings.vue?vue&type=style&index=0&id=7bf5a87a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7bf5a87a"]])

export default __exports__